var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#6C33B5",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.6666L18 20.3333V27.3333C18 33.8083 22.48 39.8633 28.5 41.3333C34.52 39.8633 39 33.8083 39 27.3333V20.3333L28.5 15.6666ZM28.5 20.3333C29.4283 20.3333 30.3185 20.702 30.9749 21.3584C31.6313 22.0148 32 22.905 32 23.8333C32 24.7616 31.6313 25.6518 30.9749 26.3082C30.3185 26.9645 29.4283 27.3333 28.5 27.3333C27.5717 27.3333 26.6815 26.9645 26.0251 26.3082C25.3687 25.6518 25 24.7616 25 23.8333C25 22.905 25.3687 22.0148 26.0251 21.3584C26.6815 20.702 27.5717 20.3333 28.5 20.3333ZM34.485 34.3333C33.0707 36.4964 30.9587 38.1103 28.5 38.9066C26.0413 38.1103 23.9293 36.4964 22.515 34.3333C22.1183 33.75 21.78 33.1666 21.5 32.5483C21.5 30.6233 24.6617 29.0483 28.5 29.0483C32.3383 29.0483 35.5 30.5883 35.5 32.5483C35.22 33.1666 34.8817 33.75 34.485 34.3333Z",
    fill: "#7B3BCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon1);
export default __webpack_public_path__ + "static/media/homeicon_1.ba103610773db56fb9f1385fa8ad2192.svg";
export { ForwardRef as ReactComponent };